import React, { useEffect, useState } from 'react';

const CountdownTimer = ({ initialSeconds = 900, onTimeout, onClosingStart }) => {
  const [secondsRemaining, setSecondsRemaining] = useState(initialSeconds);

  useEffect(() => {
    if (secondsRemaining <= 0) return;

    const timer = setInterval(() => {
      setSecondsRemaining(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onClosingStart?.(); // Start spinner
          setTimeout(() => {
            onTimeout?.();     // Trigger close
          }, 1500); // Delay before closing
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsRemaining, onTimeout, onClosingStart]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60).toString().padStart(2, '0');
    const s = (seconds % 60).toString().padStart(2, '0');
    return `${m}:${s}`;
  };

  return (
    <div style={{ margin: '10px 0' }}>
      <strong>Time remaining:</strong>
      <p>{formatTime(secondsRemaining)}</p>
      {secondsRemaining === 0 && (
        <p style={{ color: 'red' }}>⏰ Time expired. Wallet will close shortly...</p>
      )}
    </div>
  );
};

export default CountdownTimer;
